import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién empiezo a dar clases de energías renovables?',
    a: 'Sí. El Tomo 1 arranca desde la planificación anual y el diseño curricular base. El sistema está pensado tanto para docentes que empiezan como para los que quieren reorganizar y profesionalizar su material después de años de enseñanza.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de la compra recibís un correo con el enlace de descarga. Todo en formato PDF y archivos editables. Acceso de por vida desde cualquier dispositivo.'
  }, {
    q: '¿La Mega Biblioteca Premium es necesaria?',
    a: 'Depende de tu perfil. Si querés enseñar contenidos avanzados, vincular tu escuela con el sector productivo o llevar alumnos a concursos nacionales, sí es fundamental. Si recién arrancás, el Megapack base cubre todo el ciclo lectivo completo.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'Podés tener tu primera clase lista en menos de 30 minutos. La planificación anual en 2 horas. El material está pensado para usar directamente, sin necesidad de adaptación extensa.'
  }, {
    q: '¿La garantía es real?',
    a: '100% real. Escribís a nuestro correo dentro de los 7 días y te devolvemos el dinero completo. Sin formularios, sin explicaciones, sin demoras.'
  }, {
    q: '¿Es aplicable a cualquier nivel técnico?',
    a: 'Sí. El material está alineado con los diseños curriculares de escuelas técnicas, secundarias con orientación, bachilleratos y formación profesional de toda Argentina.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#06140d]" data-id="element-48">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-49">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-50">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-[#1a3d2c] rounded-2xl overflow-hidden bg-[#0c241a]/60" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 hover:bg-[#1a3d2c]/40 transition-colors" aria-expanded={openIndex === i} data-id="element-53">
                <span className="font-bold text-white pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-[#1a3d2c] pt-3" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}